/** Central Aeviot brand constants for the marketing site */

export const brandName = 'Aeviot';

export const brandLogos = {
  /** Header / light backgrounds */
  markDark: '/aeviot/aeviot-black.png',
  /** Header on dark / blue nav */
  markWhite: '/aeviot/aeviot-white.png',
  /** Favicon source (light browser chrome) */
  wordmarkDark: '/aeviot/av-logo-dark.png',
  /** Favicon source (dark browser chrome) */
  wordmarkLight: '/aeviot/av-logo-light.png',
  favicon32: '/aeviot/favicon-32.png',
  favicon32Light: '/aeviot/favicon-32-light.png',
  appleTouchIcon: '/aeviot/apple-touch-icon.png',
  appleTouchIconLight: '/aeviot/apple-touch-icon-light.png',
} as const;

export const brandEmails = {
  hello: 'hello@aeviot.com',
  partners: 'partners@aeviot.com',
  info: 'info@aeviot.com',
  support: 'support@aeviot.com',
  business: 'business@aeviot.com',
} as const;

export const brandMeta = {
  title: 'Aeviot - Smart Home IoT Platform',
  description:
    'Aeviot - Smart Home IoT Platform for Hardware Manufacturers. Complete white-label solution with cloud infrastructure, mobile apps, and firmware SDK.',
  shortName: 'Aeviot',
  fullName: 'Aeviot - Smart Home IoT Platform',
} as const;
